module.exports = __webpack_public_path__ + "static/thy3-c5918b26cf27bf655457108eb0370202.png";